import {app} from "@tva/app";
import {downgradeInjectable} from "@angular/upgrade/static";
import {UnsavedChangesService} from "@tva/ng-migration/shared/services/unsavedChanges.service";

app.factory('unsavedChanges', downgradeInjectable(UnsavedChangesService));
